"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const CustomToolTip = (0, material_1.styled)(material_1.Tooltip)({ fontSize: "1em" });
exports.default = ({ title, placement, children }) => (react_1.default.createElement(CustomToolTip, { arrow: true, title: title, placement: placement }, children));
